import React from 'react';
import welcomeImage from '../../../images/image 57.webp';
import { Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DashboardWelcome = () => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="bg-white text-center rounded-lg max-w-md">
        <h1 className="text-2xl font-bold mb-6">Welcome to Your Dashboard!</h1>
        <p className="text-gray-600 mb-6">
          Find and connect with top manufacturers to get started on your
          projects.
        </p>
        <div className="mb-6">
          <img src={welcomeImage} alt="Illustration" className="mx-auto" />
        </div>
        <div className="flex justify-center">
          <button
            onClick={() => {
              navigate('/project/create');
            }}
            className="flex flex-row space-x-2 bg-[#7636D9] font-semibold text-white rounded-sm text-center px-4 py-2 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition ease-in-out duration-500"
          >
            <span>Create Project</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardWelcome;
